import React, { useState } from 'react';
import style from './Activity.module.css';
import { AVATAR_IMAGE } from '../../assets/image';
import TextEditor from 'shared/form/TextEditor/TextEditor';
import { Button, Form } from 'react-bootstrap';
import Slate from 'shared/form/TextEditor/Slate';
import SlateEditor from 'shared/form/TextEditor/Slate';
import { Text } from 'slate';
export default function AddComment({ handleAddComment, profilePic, members }) {
  const [value, setValue] = useState('');
  const [showTextEditor, setShowTextEditor] = useState(false);
  const [cmntError, setCmntError] = useState('');

  function serializeSlateToHtml(nodes) {
    const serialize = (node) => {
      if (Text.isText(node)) {
        let text = node.text;

        if (node.bold) text = `<strong>${text}</strong>`;
        if (node.italic) text = `<em>${text}</em>`;
        if (node.underline) text = `<u>${text}</u>`;

        return text;
      }

      if (node.type === 'mention') {
        return `<span class="mention" data-id="${node.id}" data-value="${node.character}">@${node.character}</span>`;
      }

      if (node.type === 'image') {
        return `<img src="${node.url}" alt="Image" />`;
      }

      const children = node.children.map((n) => serialize(n)).join('');

      switch (node.type) {
        case 'paragraph':
          return `<p>${children}</p></br>`;
        case 'link':
          // Fallback to URL itself if no children
          return `<a href="${node.url}" target="_blank" rel="noopener noreferrer">${children || node.url}</a>`;
        case 'bulleted-list':
          return `<ul>${children}</ul>`;
        case 'numbered-list':
          return `<ol>${children}</ol>`;
        case 'list-item':
          return `<li>${children}</li>`;
        default:
          return children;
      }
    };

    return nodes.map((n) => serialize(n)).join('');
  }

  function extractMentionsFromSlate(nodes) {
    const messageUserTags = [];
    let processedMessage = '';

    const traverse = (nodes) => {
      for (const node of nodes) {
        if (Text.isText(node)) {
          processedMessage += node.text;
        } else if (node.type === 'mention') {
          processedMessage += `@${node.character} `;

          if (!messageUserTags.find((t) => t.userId === node.id)) {
            messageUserTags.push({
              tagname: node.character,
              userId: node.id
            });
          }
        } else if (node.children) {
          traverse(node.children);
          if (node.type === 'paragraph') processedMessage += '\n';
        }
      }
    };

    traverse(nodes);

    return {
      processedMessage: processedMessage.trim(),
      messageUserTags
    };
  }

  return (
    <div className={style.comment_wrapper}>
      <div className={style.comment_image}>
        <img src={profilePic || AVATAR_IMAGE} alt="avatar" />
      </div>
      {showTextEditor ? (
        <div style={{ flex: 1 }} className={style.text_editor_width}>
          <SlateEditor
            className={style.slate_editor}
            error={cmntError}
            value={value}
            onChange={(data) => {
              setValue(data);
              setCmntError('');
            }}
            members={members}
            minimalToolbar={false}
          />

          <div className={style.button_group}>
            <Button
              variant="success"
              onClick={() => {
                const htmlValue = serializeSlateToHtml(value);

                const plainText = htmlValue.replace(/<(.|\n)*?>/g, '').trim();
                if (!plainText) {
                  setCmntError('A comment is required to proceed.');
                  return;
                }

                const { messageUserTags, processedMessage } = extractMentionsFromSlate(value);

                handleAddComment(htmlValue, messageUserTags, processedMessage);
                setShowTextEditor(false);
                setValue([]);
              }}>
              Save
            </Button>
            <Button variant="link" onClick={() => setShowTextEditor(false)}>
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <Form.Group
          style={{ flex: 1 }}
          className=""
          controlId="exampleForm.ControlInput1"
          onClick={() => setShowTextEditor(true)}>
          <Form.Control placeholder="Write a comment" className={style.comment_input} />
        </Form.Group>
      )}
    </div>
  );
}
